import {
    SIGN_IN,
    SIGN_IN_FAIL,
    SIGN_OUT,
    SIGN_OUT_SUCCESS,
    SIGN_UP,
    SIGN_UP_FAIL,
    SIGN_UP_SUCCESS,
    SIGN_IN_SUCCESS,
    SIGN_OUT_FAIL,
    VERIFY,
    VERIFY_SUCCESS,
    VERIFY_FAIL,
    RESEND,
    RESEND_FAIL,
    RESEND_SUCCESS,
    SIGN_IN_FAIL_NOT_REGISTERED,
    SIGN_IN_FAIL_NOT_VERIFIED,
    SIGN_UP_FAIL_NOT_WHITELISTED,
    NAVIGATE_REGISTER,
    NAVIGATE_LOGIN,
    TOKEN_ERROR,
    RESET_SUBMIT,
    RESET_SUBMIT_SUCCESS,
    RESET_SUBMIT_FAIL,
    RESET_REQUEST,
    RESET_REQUEST_SUCCESS,
    RESET_REQUEST_FAIL, NAVIGATE_RESET_PASSWORD
} from '../actions/auth'
import { EDIT_CURRENT_USER } from '../actions/users'

const initialState = {
    view: 'login',
    loading: undefined,
    errorMessage: undefined,

    user: undefined,
    isAuthenticated: undefined,
    token: localStorage.getItem('token'),

    resetRequested: undefined
}

export default function (state = initialState, action) {
    var ns = {
        ...state,
        loading: false,
        errorMessage: null,
    }

    switch (action.type) {
        // Loading...
        case SIGN_UP:
        case SIGN_IN:
        case SIGN_OUT:
        case VERIFY:
        case RESEND:
        case RESET_REQUEST:
        case RESET_SUBMIT:
            ns.loading = true
            break

        // Generic errors
        case SIGN_UP_FAIL:
        case SIGN_IN_FAIL:
        case VERIFY_FAIL:
        case RESEND_FAIL:
        case RESET_SUBMIT_FAIL:
        case RESET_REQUEST_FAIL:
            ns.errorMessage =
                action.payload.errorMessage ||
                'An error occured. Please try again.'
            break

        case SIGN_UP_SUCCESS:
            ns.view = 'verify'
            break

        case SIGN_UP_FAIL_NOT_WHITELISTED:
            ns.errorMessage =
                "You don't have permission to access this content. Please contact the coordination team."
            break

        // SIGN IN

        case SIGN_IN_SUCCESS:
            localStorage.setItem('token', action.payload.token)
            ns.token = action.payload.token
            ns.user = action.payload.user
            ns.isAuthenticated = true
            ns.view = 'home'
            break

        case SIGN_IN_FAIL_NOT_VERIFIED:
            ns.errorMessage = 'Account not verified.'
            ns.view = 'verify'
            break

        case SIGN_IN_FAIL_NOT_REGISTERED:
            ns.errorMessage = 'User not found. Are you registered?'
            ns.view = 'register'
            break

        // SIGN OUT

        case SIGN_OUT_SUCCESS:
        case SIGN_OUT_FAIL:
        case TOKEN_ERROR:
            localStorage.removeItem('token')
            ns.token = null
            ns.view = 'login'
            ns.isAuthenticated = false
            break

        // VERIFY

        case VERIFY_SUCCESS:
            ns.view = 'login'
            break

        // RESEND

        case RESEND_SUCCESS:
            break
        
        case RESET_REQUEST_SUCCESS:
            ns.resetRequested = true
            break

        case RESET_SUBMIT_SUCCESS:
            ns.view = 'login'
            ns.resetRequested = false
            break

        // NAVIGATION
        case NAVIGATE_REGISTER:
            ns.view = 'register'
            break
        case NAVIGATE_LOGIN:
            ns.view = 'login'
            break
        case NAVIGATE_RESET_PASSWORD:
            ns.view = 'reset'
            break

        case EDIT_CURRENT_USER:
            return {
                ...state,
                user: action.payload,
            }

        default:
            return state
    }

    return ns
}
